import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import "./App.css";

import ScrollToTop from "./helper/scroll-to-top";
import BackToTop from "./helper/back-to-top";
import Footer from "./components/Footer/footer";

import PrivacyPolicy from "./pages/privacy-policy";
import Accessibility from "./pages/accessibility";

// Main pages
const Header = lazy(() => import("./components/Header/Header"));
const Home = lazy(() => import("./pages/home"));
const ClientsPage = lazy(() => import("./pages/Clients"));
const Contact = lazy(() => import("./pages/Contact"));
const AboutPage = lazy(() => import("./pages/About"));
const ServicesPage = lazy(() => import("./pages/Services"));

// Service pages
const AIGovernanceCybersecurity = lazy(() =>
  import("./components/Services/ai-governance-cybersecurity")
);

const CybersecuritySolutions = lazy(() =>
  import("./components/Services/cybersecurity-solutions")
);

const ChangeManagementAndITServiceManagement = lazy(() =>
  import("./components/Services/change-and-IT-management")
);

const EnterpriseServices = lazy(() =>
  import("./components/Services/enterprise-services")
);

const TransportationSolutions = lazy(() =>
  import("./components/Services/transportation-solutions")
);

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Suspense fallback={<div className="page-loading">Loading...</div>}>
        <Header />

        <main>
          <Routes>
            {/* Main pages */}
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/contact-us" element={<Contact />} />

            {/* Services dropdown pages */}
            <Route
              path="/services/ai-governance-cybersecurity"
              element={<AIGovernanceCybersecurity />}
            />

            <Route
              path="/services/cybersecurity-solutions"
              element={<CybersecuritySolutions />}
            />

            <Route
              path="/services/change-and-it-management"
              element={<ChangeManagementAndITServiceManagement />}
            />

            <Route
              path="/services/enterprise-services"
              element={<EnterpriseServices />}
            />

            <Route
              path="/services/transportation-solutions"
              element={<TransportationSolutions />}
            />

            {/* Footer policy pages */}
            <Route
              path="/privacy-policy"
              element={<PrivacyPolicy />}
            />

            <Route
              path="/accessibility"
              element={<Accessibility />}
            />
          </Routes>
        </main>

        <Footer />
      </Suspense>

      <BackToTop />
    </Router>
  );
}

export default App;